import ReactStars from "react-rating-stars-component";
export const CompanyRating = ({rating, count}) => {
  return (
    <span>
      <ReactStars value={rating} size={24} />
      <span>({count})</span>
    </span>
  );
};
